<!-- 临时作业 -->
<template>
    <div>
        <el-dialog title="查看作业" :visible.sync="dialogFormVisible">

            <el-card style="margin-bottom: 20px;">
                <el-row>
                    <el-col style="text-align: left;" :span="20"><h4 style="color: #409EFF;"><span>阅读/应试：{{ detail.number }}</span>  <span style="margin-left: 20px;">完成情况：{{ detail.complete }}</span> <span style="margin-left: 20px;">作业时间：{{ detail.start_time }} 至 {{ detail.end_time }}</span></h4></el-col>

                    <el-col style="text-align: right;" :span="4"><el-button @click="doway_" type="primary" size="mini" class="el-icon-mouse"> 查看完成情况</el-button></el-col>
                </el-row>
                
            </el-card>
            <el-card style="margin-bottom: 20px;" v-if="detail.read.length">
                <h4 style="color: #409EFF;">阅读在线</h4>
                <el-table
               
                    :data="detail.read"
                    highlight-current-row
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="50">
                    </el-table-column>
                    <el-table-column
                    property="title"
                    label="材料名称">
                    </el-table-column>
                    <el-table-column
                    property="type_text"
                    label="类型"
                    width="120">
                    </el-table-column>
     
                </el-table>
            </el-card>
            <el-card v-if="detail.specialty.length">
                <h4 style="color: #409EFF;">应试英语</h4>
                <el-table
          
                    :data="detail.specialty"
                    highlight-current-row
      
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="50">
                    </el-table-column>
                    <el-table-column
                    property="title"
                    label="材料名称">
                    </el-table-column>
                    <el-table-column
                    property="type_text"
                    label="类型"
                    width="120">
                    </el-table-column>
     
                </el-table>
            </el-card>
        
        </el-dialog>

        <el-dialog :title="`作业完成情况`" :visible.sync="dowaydialogFormVisible" @close="dowayClose">
            <el-table
                :data="student"
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="stuid"
                    label="学号">
                </el-table-column>
                <el-table-column
                    prop="number"
                    label="完成篇数">
                </el-table-column>
                <el-table-column
                    prop="rate"
                    label="正确率">
                </el-table-column>
                <!-- <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">

                        <el-button @click="dodetail(scope.row)" type="primary" size="mini">查看</el-button>
                
                    </template>
                </el-table-column> -->
            </el-table>
        
        </el-dialog>
    </div>
</template>

<script>
import Http from "../src/apis/work";
export default {
    data(){
        return{
            dialogFormVisible:false,
            dowaydialogFormVisible:false,
            detail:[],
            task_id:'',
            plan_id:'',
            studentDodialog:false,
            student:[],
        }
    },
    
    methods:{
        viewWorkDetail(task_id,plan_id){
            this.task_id = task_id
            this.plan_id = plan_id
            var params = {}
            params.task_id = task_id
            params.plan_id = plan_id
            Http.getTemporaryWorkDetail(params).then((res) => {
                this.detail = res.data
                this.dialogFormVisible = true
            });
        },
        dowayClose(){
            this.dowaydialogFormVisible = false
            this.dialogFormVisible = true
        },
        //  查看做题情况
        doway_(){
        
            var params = {}
            params.task_id = this.task_id
            params.plan_id = this.plan_id
            
            Http.doway(params).then((res) => {
                this.dowaydialogFormVisible = true
                this.dialogFormVisible = false
                this.student = res.data
            });
        },
    }
}
</script>
<style scoped>
.el-icon-mouse{
    margin-top: 20px;
}
</style>